<template>
  <div class="portal-locked-card">
    <div class="content-card-wrapper">
      <div class="content-card" :style="style">
        <div class="locked-wrapper">
          <span>Conteúdo bloqueado</span>
          <i class="icon-lock" />
          <a
            v-if="checkoutUrl"
            class="btn btn-sm btn-primary"
            :href="checkoutUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            Quero ter acesso
          </a>
        </div>
      </div>
    </div>
    <h5 class="content-name text-wrap pt-2 mb-0">{{ content.name }}</h5>
  </div>
</template>

<script>
import get from "lodash/get";

export default {
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    cover() {
      return (
        get(this.content, "cover") ||
        get(this.content, "background") ||
        get(this.content, "logo") ||
        ""
      );
    },
    checkoutUrl() {
      return get(this.content, "checkout_url") || "";
    },
    style() {
      if (!this.cover) return "";

      return `background-image: url(${this.cover});`;
    }
  }
};
</script>

<style lang="scss" scoped>
.portal-locked-card {
  .content-card-wrapper {
    border-radius: 6px;

    .content-card {
      aspect-ratio: 200/290;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      height: 100%;
      width: 100%;
      border-radius: 6px;
      position: relative;
    }

    .locked-wrapper {
      background: rgba(50, 28, 61, 0.8);
      border-radius: 6px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      gap: 16px;
      font-weight: 500;
      color: #bebfc7;
      padding: 0 12px;
      display: flex;
      text-align: center;
      align-items: center;
      flex-direction: column;
      justify-content: center;

      i {
        color: #ffffffcc;
        font-size: 32px;

        @media screen and (max-width: 768px) {
          font-size: 28px;
        }

        @media screen and (max-width: 540px) {
          font-size: 20px;
        }
      }
    }
  }

  .content-name {
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;

    @media screen and (max-width: 768px) {
      font-size: 12px !important;
    }
  }
}
</style>
